export default "__VITE_ASSET__CmwV_w1n__"